import { CenterItem, Column, Row } from '@components/LinearLayout';

import { PBold } from '@components/Typography';
import { styled } from 'styled-components';

export const VideoPlayerContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  margin-bottom: 2rem;
  position: relative;
  padding-top: 56.25%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: auto;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    display: flex;
    flex-direction: column;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const VideoDetails = styled(Column)`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: auto;
  padding: 1rem 1rem 2rem 1rem;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  background: rgba(91.37, 91.37, 91.37, 0.65);
  box-shadow: 0.4rem 0.4rem 0.4rem;
  z-index: 10001;
`;

export const VideoTitle = styled(PBold)`
  text-align: center;
  color: ${({ theme }) => theme.color.white};
`;

export const VideoControls = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr auto;
  padding: 0 2rem;
  gap: 0.8rem;
`;

export const PlayerButton = styled(CenterItem)`
  &:hover {
    cursor: pointer;
  }
`;

export const SliderWrapper = styled(CenterItem)`
  height: 100%;
`;

export const VideosControlsTablet = styled(Row)`
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  gap: 0.8rem;
`;

export const ProgressRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 0 2rem;
  gap: 0.8rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0;
  }
`;

export const VolumeIconWrapper = styled(CenterItem)`
  &:hover {
    cursor: pointer;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    i {
      width: auto;
    }
  }
`;

export const HoverInput = styled.input`
  &:hover {
    cursor: pointer;
  }
`;

export const MobileVideoDetails = styled(Column)`
  background: ${({ theme }) => theme.color.shadeGrey4};
  width: 100%;
  padding: 1rem;
  margin-bottom: 2rem;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.radius10};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: auto;
    margin-bottom: 2rem;
  }
`;

export const CookiePermissionContainer = styled(Column)`
  gap: 3rem;
  min-height: max(40rem, 50vh);
  align-items: center;
  justify-content: center;
`;
